module.exports = __webpack_public_path__ + "img/6.20a3649.svg";